<!-- 
Workflow for a levy collection.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="getBreadcrumbs('workflow')"
      :subtitle="statusDescription"
      title="Workflow"
      subtitle-tooltip="Levy collection status"
      user-guide-topic="levy-collection-workflow"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <v-card class="home">
      <status-timeline :levy-collection-id="levyCollectionId" transparent />
      <v-layout row wrap>
        <v-flex grow>
          <v-text-field
            v-model="search"
            outline
            label="Search for collection or provider tasks"
            prepend-inner-icon="search"
            clearable
            hide-details
            class="ml-3 mt-3 mb-2 mr-3"
          />
        </v-flex>
        <v-flex :shrink="!xs" :class="{xs12:xs, 'mx-3': xs}" mt-3>
          <warnings-menu :levy-collection-id="levyCollectionId" large />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm6 md5>
          <div class="pl-3">
            <h2 class="headline text-uppercase mt-0 pt-3">Collection tasks</h2>
            <tasks-panel :levy-collection-id="levyCollectionId" :search="search"/>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md7>
          <h2 class="headline text-uppercase ml-4 mt-0 pt-3">Provider tasks</h2>
          <all-provider-tasks-panel :levy-collection-id="levyCollectionId" :search="search" />
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import WarningsMenu from "@/components/levy-collections/WarningsMenu.vue";
import StatusTimeline from "@/components/levy-collections/StatusTimeline.vue";
import TasksPanel from "@/components/levy-collections/TasksPanel.vue";
import AllProviderTasksPanel from "@/components/levy-collections/AllProviderTasksPanel.vue";
import levyCollectionMixins from "./mixins";

export default {
  components: {
    LevyCollectionNavigator,
    WarningsMenu,
    AllProviderTasksPanel,
    TasksPanel,
    StatusTimeline
  },
  mixins: [levyCollectionMixins],
  data() {
    return {
      redirectIfSandbox: true,
      search: ""
    };
  },
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  }
};
</script>
